// removed by extract-text-webpack-plugin
module.exports = {"p-name-container":"p-name-container__FyoSh","p-details-container":"p-details-container__3lcNR","btn-container":"btn-container__3469R","prev":"prev__2DaOk","next":"next__2K1rc","next-main":"next-main__1kqVI","pb-0":"pb-0__3BpUN","mb275":"mb275__2B4on","screen-img":"screen-img__3W-xq"};


//////////////////
// WEBPACK FOOTER
// ./styles/f2s/screen2.scss
// module id = 97
// module chunks = 68